export enum DataHooks {
  ROOT = 'layout-image-root',
  WRAPPER = 'layout-image-wrapper',
  CONTAINER = 'layout-image-container',
  IMAGE = 'layout-image',
  LINK = 'layout-image-link',
}
